export const NODE_NAME = 'hard_break';
